import { CustomBuilderComponents } from '@/helpers/enums';

export const headingBlockBuilderConfigs = {
  name: CustomBuilderComponents.HEADING_BLOCK,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/toolbar-bottom.svg',
  inputs: [
    {
      name: 'header',
      type: 'string',
    },
    {
      name: 'subheader',
      type: 'customRichTextPistachios',
    },
    {
      name: 'image',
      type: 'object',
      subFields: [
        {
          name: 'src',
          friendlyName: 'Image source',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png'],
        },
        {
          name: 'altText',
          friendlyName: 'Image description text',
          type: 'string',
        },
      ],
    },
  ],
};
